"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
const seriesProcessor = params => {
  const {
    series,
    seriesOrder
  } = params;
  const defaultizedSeries = {};
  Object.keys(series).forEach(seriesId => {
    defaultizedSeries[seriesId] = (0, _extends2.default)({
      // Defaultize the data and the value formatter.
      valueFormatter: v => v[2].toString(),
      data: [],
      labelMarkType: 'square'
    }, series[seriesId]);
  });
  return {
    series: defaultizedSeries,
    seriesOrder
  };
};
var _default = exports.default = seriesProcessor;